import { SettingsCard, SettingsOptionList, SettingsOptionRow } from '@vyce/core/src/components/SettingsCard';

import { ClockOutOutsideSettings } from '../../../../types';

interface Props {
  clockOutOutsideSettings: ClockOutOutsideSettings | null;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  updatePreferences: (settings: ClockOutOutsideSettings) => void;
}

export const ZeroHoursForClockOuts = ({
  clockOutOutsideSettings,
  expanded,
  onExpandedChange,
  updatePreferences,
}: Props) => {
  const isFirm = clockOutOutsideSettings === ClockOutOutsideSettings.FIRM;

  return (
    <SettingsCard
      title="Clock outs away from site"
      description="Sometimes people clock out away from the work location. Vyce always flags it in Time Logs — here you choose whether it also changes their pay."
      status={isFirm ? 'Paid as zero hours' : 'Paid as normal shift'}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
    >
      <SettingsOptionList>
        <SettingsOptionRow
          label="Pay zero hours"
          hint="Zeroes the day's paid hours. The clock out is still shown in Time Logs so you can review it."
          selected={isFirm}
          onSelect={() => updatePreferences(ClockOutOutsideSettings.FIRM)}
        />

        <SettingsOptionRow
          label="Pay their normal shift"
          hint="Pay is unchanged — you just get the flag in Time Logs."
          selected={clockOutOutsideSettings === ClockOutOutsideSettings.FLEXIBLE}
          onSelect={() => updatePreferences(ClockOutOutsideSettings.FLEXIBLE)}
        />
      </SettingsOptionList>
    </SettingsCard>
  );
};
